import React from "react";
import Layout from "../components/layout-dark";
import { Script } from "gatsby";

function LayoutContainer(props) {
  return (
    <>
      <Layout {...props} />
      <Script id='web-tags' dangerouslySetInnerHTML={{__html: `
        // 6sense Tag
window._6si = window._6si || [];
window._6si.push(['enableEventTracking', true]);
window._6si.push(['setToken', 'f144e1faf8e4fbbefdd88d3be24f368e']);
window._6si.push(['setEndpoint', 'b.6sc.co']);



(function() {
var gd = document.createElement('script');
gd.type = 'text/javascript';
gd.async = true;
gd.src = '//j.6sc.co/6si.min.js';
var s = document.getElementsByTagName('script')[0];
s.parentNode.insertBefore(gd, s);
})();

// Demandbase Tag
(function(d,b,a,s,e){ var t = b.createElement(a),
  fs = b.getElementsByTagName(a)[0]; t.async=1; t.id=e; t.src=s;
  fs.parentNode.insertBefore(t, fs); })
(window,document,'script','https://tag.demandbase.com/4c9ebf0d094202aa.min.js','demandbase_js_lib');  
`}} />
    </>
  );
}

export default LayoutContainer;
